import * as MealsSelectors from './MealsSelectors';

export const getFlights = state => state.toJS();

export const getFlight = (state, flight) => {
  let selectedFlight = flight - 1 >= 0 ? flight - 1 : 0;
  return state[ selectedFlight ];
};

export const getFlightByRouteId = (state, routeId) =>
  state.find(flight => flight.routeId === routeId);

export const getSeatsForFlightByRouteId = (state, routeId) =>
  state.find(flight => flight.routeId === routeId).seats;

export const getPassengersForFlightWithSeats = (state, routeId) =>
  state
    .find(flight => flight.routeId === routeId)
    .passengers.filter(passenger => !!passenger.seatId);

export const prepareFlightsForReview = (flights, routes, passengers) => {
  let preparedFlights = [];
  preparedFlights = pairRoutesAndPassengersForFlights(flights, routes, passengers);
  preparedFlights = pairSeatsForPassengers(flights);
  preparedFlights = pairMealsForPassengers(flights);
  return preparedFlights;
};

export const pairRoutesAndPassengersForFlights = (flights, routes, passengers) => {
  let flightsWithRoutes = [];
  for (let i = 0; i < flights.length; i++) {
    let flight = flights[ i ];
    let flightPassengers = [];
    for (let j = 0; j < passengers.length; j++) {
      let fullPassengerInfo = passengers[ j ];
      if (flight.passengers) {
        flight.passengers.find(passenger => {
          if (passenger.id === fullPassengerInfo.id) {
            flightPassengers.push(Object.assign({}, passenger, fullPassengerInfo));
          }
        });
      }
    }
    flight.passengers = flightPassengers;
    let currentRoute = routes.find(route => flight.routeId === route.id);
    if (currentRoute) {
      flight.from = currentRoute.departure;
      flight.to = currentRoute.arrival;
      flightsWithRoutes.push(flight);
    } else {
      flightsWithRoutes.push(flight);
    }
  }
  return flightsWithRoutes;
};

export const pairSeatsForPassengers = flights => {
  for (let i = 0; i < flights.length; i++) {
    for (let j = 0; j < flights[ i ].passengers.length; j++) {
      let passenger = flights[ i ].passengers[ j ];
      let seat = flights[ i ].seats.seats.find(seat => seat.seatId === passenger.seatId);
      passenger.seatPreview = seat ? `${seat.row}${seat.seatNum}` : '';
    }
  }
  return flights;
};

export const pairMealsForPassengers = flights => {
  for (let i = 0; i < flights.length; i++) {
    let currentFlight = flights[ i ];
    for (let j = 0; j < currentFlight.passengers.length; j++) {
      let passenger = currentFlight.passengers[ j ];
      let selectedMeals = MealsSelectors.getSelectedMealsForFlight(currentFlight);
      let selectedMealForPassenger = selectedMeals.find(
        passengerMeal => passengerMeal.id === passenger.id
      );
      if (selectedMealForPassenger && selectedMealForPassenger.meals) {
        let allMeals = currentFlight.meals;
        selectedMealForPassenger.meals.map(selectedMeal => {
          if (allMeals && allMeals.category) {
            let selectedCategory = allMeals.category.find(
              category =>
                category && category.label && category.label.toLowerCase() === selectedMeal.type
            );
            if (selectedCategory && selectedCategory.items) {
              let fullMeal = selectedCategory.items.find(meal => meal.id === selectedMeal.id);
              if (fullMeal) {
                selectedMeal.info = fullMeal.description;
                selectedMeal.title = selectedCategory.label;
                selectedMeal.subselectionTitle =
                  fullMeal.subselection && fullMeal.subselection.label ?
                    fullMeal.subselection.label :
                    '';
              }
            }
          }
        });
      }

      if (!selectedMealForPassenger) {
        selectedMealForPassenger = { meals: [] };
      }

      currentFlight.passengers[ j ] = Object.assign({}, passenger, selectedMealForPassenger);
      flights[ i ] = currentFlight;
    }
  }
  return flights;
};



// WEBPACK FOOTER //
// ./src/redux/selectors/FlightsSelectors.js